import { Button } from '@mui/material'
import { ConfirmIcon } from '$common/icons/confirm-icon'
import { t } from '$i18n'

export function ConfirmCancelBox({
  onConfirm,
  onReset,
}: {
  onReset: () => unknown
  onConfirm: () => unknown
}) {
  return (
    <div
      style={{
        height: '56px',
        width: '100%',
        padding: '8px',
        display: 'flex',
        justifyContent: 'space-between',
        bottom: 0,
      }}
    >
      <Button
        variant="text"
        color="secondary"
        startIcon={<ConfirmIcon />}
        onClick={onConfirm}
      >
        {t('common.ok')}
      </Button>
      <Button
        variant="text"
        sx={{ minWidth: 'unset', color: 'white' }}
        onClick={onReset}
      >
        {t('common.cancel')}
      </Button>
    </div>
  )
}
